import { useState, useRef, useContext, useEffect } from "react";
import Webcam from "webcam-react";
import "./style.css";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import AlertMessage from "../../Alert";
import { CadastroContext } from "../../../contexts/CadastroContext";
import { Load } from "../../Load";
import { session, StorageKeys } from "../../../services/storage.service";
import { AsoInformation } from "../../../types/aso-information";

const AssinaturaReaproveitamentoAso = () => {
	const [alert, setAlert] = useState({
		show: false,
		message: "",
		variant: "success",
	});
	const { cadastro, handleCadastroChange } = useContext(CadastroContext);
	const [photoBase64, setPhotoBase64] = useState<string | null>(null);
	const [isLoading, setIsLoading] = useState(false);
	const [_, setFrenteDocumento] = useState("");
	const webcamRef = useRef<any>(null);
	const { idConsulta, dbName } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		if (!cadastro.primeiraVez) {
			const handlePopState = (_: PopStateEvent) => {
				// Re-adiciona a entrada ao histórico
				window.history.pushState(null, "", window.location.pathname);
			};

			const loop = () => {
				window.history.pushState(null, "", window.location.pathname);
				setTimeout(loop, 100);
			};

			window.history.pushState(null, "", window.location.pathname);
			window.addEventListener("popstate", handlePopState);

			loop();

			return () => {
				window.removeEventListener("popstate", handlePopState);
			};
		}
		if (cadastro.primeiraVez) {
			cadastro.editarCadastro = true;
			handleCadastroChange(cadastro);
		}
	}, [cadastro, handleCadastroChange]);

	const capturePhoto = async () => {
		if (webcamRef.current) {
			const dataUri = await webcamRef.current.getScreenshot();
			setPhotoBase64(dataUri);
			setFrenteDocumento(cadastro.frenteDocumento);
		}
	};

	const handleContinue = async () => {
		try {
			if (photoBase64) {
				setIsLoading(true);
				cadastro.fotoRosto = photoBase64;
				handleCadastroChange(cadastro);
				const asoInformation = session.get<AsoInformation>(
					StorageKeys.ASO_INFORMATION,
				)!;
				const signed = await api.post("/salvar-assinatura-reaproveitamento", {
					fotoRosto: photoBase64,
					idConsulta,
					email: asoInformation.email,
					dbName,
				});
				if (signed.status === 200) {
					navigate("/aso/registro/documento-assinado-sucesso");
				} else {
					setIsLoading(false);
					setAlert({
						show: true,
						message: "Erro ao comparar identidade. Tente novamente.",
						variant: "danger",
					});
				}
			}
		} catch {
			setIsLoading(false);
			setAlert({
				show: true,
				message: "Erro ao comparar identidade. Tente novamente.",
				variant: "danger",
			});
		}
	};

	const handleRetake = () => {
		setPhotoBase64(null);
	};

	// const handleVoltar = () => {
	// 	cadastro.editarCadastro = true;
	// 	handleCadastroChange(cadastro);
	// 	return navigate(
	// 		`/aso/registro/validar-info/${cadastro.idConsulta}/${dbName}`,
	// 	);
	// };

	return (
		<>
			{isLoading && <Load isLoading={isLoading} />}
			{!isLoading && (
				<div className="camera-container">
					{!photoBase64 && (
						<div className="camera-wrapper">
							<h1 className="instruction-title">
								Por favor, remova quaisquer acessórios do rosto, posicione-se em
								um local bem iluminado e mantenha uma expressão neutra.
							</h1>
							<Webcam
								audio={false}
								screenshotFormat="image/jpeg"
								width={400}
								height={550}
								className="webcam"
								ref={webcamRef}
								mirrored={true}
							/>
							<div className="pre-foto-buttons-container">
								<button
									type="button"
									onClick={capturePhoto}
									className="capture-button"
								>
									Tirar Foto
								</button>
							</div>
						</div>
					)}
					{photoBase64 && (
						<div className="confirm-wrapper">
							<h1 className="verification-title">
								Por favor, verifique se a foto está bem iluminada e se o rosto
								está visível antes de continuar.
							</h1>
							<img
								src={photoBase64 || ""}
								alt="Foto tirada"
								className="captured-image"
							/>
							<div className="buttons-wrapper">
								<button
									type="button"
									onClick={handleContinue}
									className="continue-button"
								>
									Continuar
								</button>
								<button
									type="button"
									onClick={handleRetake}
									className="retake-button"
								>
									Tirar outra foto
								</button>
							</div>
						</div>
					)}
					<AlertMessage
						show={alert.show}
						message={alert.message}
						variant={alert.variant}
						onClose={() => setAlert({ ...alert, show: false })}
					/>
				</div>
			)}
		</>
	);
};

export default AssinaturaReaproveitamentoAso;
